module.exports = __webpack_public_path__ + "static/media/ah-post2.fe86d6ba.png";